import { render } from "./DefaultColumn.vue?vue&type=template&id=0b7d5022"
import script from "./DefaultColumn.vue?vue&type=script&lang=js"
export * from "./DefaultColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__